import React from "react";
import { Modal } from "react-bootstrap";

export function ConfirmationModal({
  onHide,
  show,
  onClick,
  modalTitle,
  modalTitleContent,
  modalSubContent,
}) {
  return (
    <div>
      <Modal
        size="md"
        show={show}
        centered
        onHide={onHide}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {modalTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ textAlign: "center" }}>
            <i
              className="fas fa-exclamation-circle"
              style={{ fontSize: "64px", color: "#F23013" }}
            ></i>
          </div>
          <div className="mt-8 text-center">
            <strong>{modalTitleContent}</strong>
            <br />
            <span className="mt-8 text-danger">{modalSubContent}</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              onClick={onHide}
              className="btn btn-light btn-elevate"
            >
              Cancel
            </button>
            <> </>
            <button
              type="button"
              onClick={onClick}
              className="btn btn-primary btn-elevate"
            >
              Yakin
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
